import React from 'react';
import 'regenerator-runtime/runtime';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone'

import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import {styled} from '@mui/system';

import ActionButton from './atoms/ActionButton';
import GlobalContext from '../helpers/context';


const StyledDropZone = styled('div')({
    borderColor: '#cccccc',
    borderStyle: 'dashed',
    borderRadius: 5,
    borderWidth: 2,
    backgroundColor: '#eeeeee',
    textAlign: 'center',
    color: '#777777',
    paddingTop: 70,
    paddingBottom: 70,
    width: 450
});

const StyledFiles = styled('span')(({ theme }) =>({
    fontWeight: 500,
    color: '#000000',
    fontSize: theme.custom.font.large,
    borderRadius: 15,
    background: '#cccccc',
    padding: '5px 10px'
}));


class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            counter: 0,
            dropped_file: null
        };

        this.title = this.props.title ? this.props.title : 'Upload files';
        this.dropzoneText = this.props.dropzoneText ? this.props.dropzoneText : 'Drag and drop a file here or click';
        this.acceptedFiles = this.props.acceptedFiles ? this.props.acceptedFiles : ['text/*', 'image/*', 'application/*'];
        this.maxFileSize = this.props.maxFileSize ? this.props.maxFileSize : 5 * 1048576;
        this.filesLimit = 1;

    }

    handleClose = () => {
        this.props.closeCallback();
        this.setState({
            counter: this.state.counter + 1,
            dropped_file: null
        });
    };

    handleSave = (files) => {
        this.props.saveCallback(this.state.dropped_file);
        this.setState({dropped_file: null});
    };

    handleDrop = (files) => {
        this.setState({dropped_file: null});
    };

    handleDropRejected = (files) => {
        if (files[0] && files[0].errors && files[0].errors[0].message && files[0].file && files[0].file.path) {
            this.context.displayGlobalError('File ' + files[0].file.path + ' was rejected. ' + files[0].errors[0].message + '.');
        }
    };

    handleDropAccepted = (files) => {
        // will select the first file only!
        if(files[0] && files[0].path){
             this.setState({dropped_file: files[0]});
        }
    };

    render() {
        let title = this.title;
        let acceptedFiles = this.acceptedFiles;
        let filesLimit = this.filesLimit;
        let maxFileSize = this.maxFileSize;
        let dropzoneText = this.dropzoneText;
        let dropped_file = this.state.dropped_file;
        return (
            <GlobalContext.Consumer>{() => (
                <Dialog
                    open={this.props.open}
                    onClose={this.handleClose.bind(this)}
                    aria-labelledby="responsive-dialog-title"
                    key={this.state.counter}
                >
                    <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
                    <DialogContent>
                        <Dropzone
                            accept={{acceptedFiles}}
                            maxFiles={filesLimit}
                            maxSize={maxFileSize}
                            onDrop={droppedFiles => this.handleDrop(droppedFiles)}
                            onDropAccepted={droppedFiles => this.handleDropAccepted(droppedFiles)}
                            onDropRejected={droppedFiles => this.handleDropRejected(droppedFiles)}
                        >
                            {({getRootProps, getInputProps}) => (
                                <section>
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <StyledDropZone>
                                            {!dropped_file && dropzoneText}
                                            {dropped_file && <StyledFiles>{dropped_file.path}</StyledFiles>}
                                        </StyledDropZone>
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                    </DialogContent>
                    <DialogActions>
                        <span>
                            <ActionButton text="Cancel" actionCallback={this.handleClose.bind(this)} linkStyle={true} hotKey="alt+x" />
                            <ActionButton text="Submit" disabled={!this.state.dropped_file} dataBt="confirm_button" actionCallback={this.handleSave.bind(this)} linkStyle={true} hotKey="alt+o" />
                        </span>
                    </DialogActions>
                </Dialog>
            )}
            </GlobalContext.Consumer>
        );
    }

}

FileUpload.contextType = GlobalContext;

FileUpload.propTypes = {
    saveCallback: PropTypes.func.isRequired,
    closeCallback: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    acceptedFiles: PropTypes.array,
    maxFileSize: PropTypes.number,
    title: PropTypes.string,
    dropzoneText: PropTypes.string
};

export default FileUpload;
